import React, { FC, memo } from "react";
import { Box } from "@chakra-ui/react";
import MediaThumbnailCover from "@modules/Layout/components/MediaThumbnailCover";
import useProductDetailPageAttrQuery from "../hooks/useProductDetailPageAttrQuery";
import { BannerHero } from "@modules/Layout/style";
import ResponsiveContainer from "@modules/Layout/components/ResponsiveContainer";

const Cover: FC = () => {
  const { data: result } = useProductDetailPageAttrQuery();
  const { banner } = result!.data.attributes;

  return (
    <Box bg={"white50"}>
      <ResponsiveContainer>
        <BannerHero>
          <MediaThumbnailCover
            data={banner}
            buttonSize={{ base: "full", sm: "auto" }}
          />
        </BannerHero>
      </ResponsiveContainer>
    </Box>
  );
};

export default memo(Cover);
